/**
 * 视觉 Token（按 v7 demo 提取）
 * Ant Design 5 主题定制 + CSS 变量同步
 */
export const tokens = {
  colors: {
    bg: '#f4f5f7',
    surface: '#ffffff',
    surfaceHover: '#f7f8fa',
    sidebarBg: '#fafbfc',
    borderLight: '#f0f1f4',
    border: '#e7e9ed',
    borderStrong: '#d4d7dd',
    text1: '#1f2329',
    text2: '#4e5969',
    text3: '#8f959e',
    text4: '#c0c4cc',
    primary: '#3370ff',
    primaryHover: '#245bdb',
    primaryBg: '#eaf2ff',
    primaryBorder: '#94bfff',
    success: '#34c759',
    successBg: '#e8f8eb',
    successText: '#1f8231',
    warning: '#ff9500',
    warningBg: '#fff4e6',
    warningText: '#b86700',
    danger: '#ff4d4f',
    dangerBg: '#fff0f0',
    dangerText: '#cf2c30',
    purple: '#7c4dff',
    purpleBg: '#f0eaff',
    purpleText: '#5828d6',
  },
  shadow: {
    xs: '0 1px 2px rgba(31, 35, 41, 0.04)',
    sm: '0 1px 3px rgba(31, 35, 41, 0.06)',
    lg: '0 12px 24px rgba(31, 35, 41, 0.08)',
    modal: '0 24px 48px rgba(31, 35, 41, 0.12)',
  },
  ease: 'cubic-bezier(0.4, 0, 0.2, 1)',
};

export const antdTheme = {
  token: {
    colorPrimary: tokens.colors.primary,
    colorSuccess: tokens.colors.success,
    colorWarning: tokens.colors.warning,
    colorError: tokens.colors.danger,
    colorInfo: tokens.colors.primary,
    colorText: tokens.colors.text1,
    colorTextSecondary: tokens.colors.text2,
    colorTextTertiary: tokens.colors.text3,
    colorTextQuaternary: tokens.colors.text4,
    colorBgContainer: tokens.colors.surface,
    colorBgLayout: tokens.colors.bg,
    colorBorder: tokens.colors.border,
    colorBorderSecondary: tokens.colors.borderLight,
    borderRadius: 6,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
  },
  components: {
    Button: {
      controlHeight: 30,
      controlHeightSM: 26,
    },
    Table: {
      headerBg: '#fafbfc',
      headerColor: tokens.colors.text3,
      cellPaddingBlock: 12,
      cellPaddingInline: 12,
    },
    Layout: {
      headerBg: tokens.colors.surface,
      siderBg: tokens.colors.sidebarBg,
      bodyBg: tokens.colors.bg,
      headerHeight: 52,
    },
    Menu: {
      itemBg: 'transparent',
      itemColor: tokens.colors.text1,
      itemSelectedBg: tokens.colors.primaryBg,
      itemSelectedColor: tokens.colors.primary,
      itemHeight: 34,
    },
  },
};
